import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check for existing session on mount
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error("Failed to parse stored user:", error);
        localStorage.removeItem("user");
      }
    }
    setLoading(false);
  }, []);

  const login = async (userData, userInfoOverride = null) => {
    const buildFullUserInfo = (userInfo) => {
      const fullNameParts = (userInfo.displayName || "").split(" ").filter(Boolean);
      return {
        firstName: userInfo.first_name || fullNameParts[0] || userData.first_name || "User",
        lastName:
          userInfo.last_name || fullNameParts.slice(1).join(" ") || userData.last_name || "",
        email: userInfo.email || userData.email || "",
        appAccess: userInfo.app_access || [],
        viewAccess: Array.isArray(userInfo.view_access)
          ? userInfo.view_access
          : Array.isArray(userInfo.viewAccess)
            ? userInfo.viewAccess
            : undefined,
        isAdmin: userInfo.isAdmin || false,
        isActive: userInfo.is_active ?? 0,
        role: userInfo.role || userData.role || "",
        userType: userInfo.user_type || userInfo.userType || userData.userType || "",
        loginTime: new Date().toISOString(),
        expiry: userInfo.expiry || "",
        userImage: userInfo.profile_image_url || "",
      };
    };

    // Fetch user info including appAccess from backend
    try {
      if (userInfoOverride) {
        const fullUserInfo = buildFullUserInfo(userInfoOverride);
        setUser(fullUserInfo);
        localStorage.setItem("user", JSON.stringify(fullUserInfo));
        return;
      }

      // const response = await fetch("/api/user/info");
      // if (response.ok) {
      //   const userInfo = await response.json();
      //   const fullUserInfo = buildFullUserInfo(userInfo);
      //   setUser(fullUserInfo);
      //   localStorage.setItem("user", JSON.stringify(fullUserInfo));

      //   // Print user login info
      //   console.log("=".repeat(60));
      //   console.log("USER LOGGED IN");
      //   console.log("=".repeat(60));
      //   console.log("Email:", fullUserInfo.email);
      //   console.log("Name:", `${fullUserInfo.firstName} ${fullUserInfo.lastName}`);
      //   console.log("App Access:", fullUserInfo.appAccess);
      //   console.log("Total Access Permissions:", fullUserInfo.appAccess.length);
      //   console.log("Is Admin:", fullUserInfo.isAdmin);
      //   console.log("Is Active:", fullUserInfo.isActive);
      //   console.log("=".repeat(60));
      // } else {
      //   // Fallback if API fails
      //   const userInfo = buildFullUserInfo({});
      //   setUser(userInfo);
      //   localStorage.setItem("user", JSON.stringify(userInfo));
      // }
    } catch (error) {
      console.error("Error fetching user info:", error);
      // Fallback if API fails
      const userInfo = buildFullUserInfo({});
      setUser(userInfo);
      localStorage.setItem("user", JSON.stringify(userInfo));
    }
  };

  const logout = () => {
    localStorage.clear();
    window.location.href = "/login";
    setUser(null);
    localStorage.removeItem("user");
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated: !!user,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
